import ExpandableText from './expandableText'

const expandableTextElements = document.querySelectorAll('.expandableText')

expandableTextElements.forEach((expandableTextElement) => {
	const expandableText = new ExpandableText({ element: expandableTextElement as HTMLElement })
	expandableText.init()
})
